import DragAndDropSingleton from './singleton'

export default DragAndDropSingleton
